import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { QueueState, QueueEntry } from "./types";
import { fetchQueueAPI, joinQueueAPI, leaveQueueAPI } from "./queueAPI";

const initialState: QueueState = {
  myQueue: null,
  queueList: [],
  loading: false,
  error: null,
};

export const fetchQueue = createAsyncThunk(
  "queue/fetch",
  async (businessId: string) => {
    return await fetchQueueAPI(businessId);
  }
);

export const joinQueue = createAsyncThunk(
  "queue/join",
  async (businessId: string) => {
    return await joinQueueAPI(businessId);
  }
);

export const leaveQueue = createAsyncThunk("queue/leave", async (queueId: string) => {
  return await leaveQueueAPI(queueId);
});

const queueSlice = createSlice({
  name: "queue",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchQueue.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchQueue.fulfilled, (state, action: PayloadAction<QueueEntry[]>) => {
        state.loading = false;
        state.queueList = action.payload;
      })
      .addCase(joinQueue.fulfilled, (state, action: PayloadAction<QueueEntry>) => {
        state.myQueue = action.payload;
      })
      .addCase(leaveQueue.fulfilled, (state) => {
        state.myQueue = null;
      })
      .addCase(fetchQueue.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Failed to fetch queue";
      });
  },
});

export default queueSlice.reducer;
